import { render } from "./Index.vue?vue&type=template&id=1b80345e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1b80345e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b80345e"],['__file',"resources/js/components/whatsapp-managment/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b80345e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b80345e', __exports__)) {
    console.log('reload')
    api.reload('1b80345e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=1b80345e&scoped=true", () => {
    console.log('re-render')
    api.rerender('1b80345e', render)
  })

}


export default __exports__